import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { isBefore, isSameDay, isValid, parseISO } from "date-fns";
import { useEffect } from "react";

// Gets initial date range from URL and sets it in the store
// covers edge cases like dates in the past or end date before start date
// Clears the cart if URL dates differ from persisted dates (e.g. user pasted a new booking link)
export const useDateURLParams = () => {
  const setDateRange = useEngineStore((state) => state.setDefaultDateRange);
  const resetCartItems = useEngineStore((state) => state.resetCartItems);
  const setPage = useEngineStore((state) => state.setPage);
  const setDefaultDateRange = () => {
    const tomorrowDate = new Date(+new Date() + 86400000);
    const dayAfterTomorrowDate = new Date(+tomorrowDate + 86400000);
    setDateRange([tomorrowDate, dayAfterTomorrowDate]);
  };

  useEffect(() => {
    const today = new Date().setHours(0, 0, 0, 0);
    const urlParams = new URLSearchParams(window.location.search);
    const startDateParam = urlParams.get(URLParam.StartDate);
    const endDateParam = urlParams.get(URLParam.EndDate);

    const startDate = startDateParam ? parseISO(startDateParam) : null;
    const endDate = endDateParam ? parseISO(endDateParam) : null;

    if (
      !startDate ||
      !endDate ||
      !isValid(startDate) ||
      !isValid(endDate) ||
      isBefore(startDate, today) ||
      isBefore(endDate, today) ||
      isBefore(endDate, startDate)
    ) {
      setDefaultDateRange();
    } else {
      // Clear cart if URL dates differ from persisted store dates
      const { defaultDateRange, cartAccommodationItems } = useEngineStore.getState();
      const [storedStart, storedEnd] = defaultDateRange;
      const datesChanged =
        cartAccommodationItems.length > 0 &&
        storedStart &&
        storedEnd &&
        (!isSameDay(new Date(storedStart), startDate) || !isSameDay(new Date(storedEnd), endDate));

      if (datesChanged) {
        resetCartItems();
        setPage(AppPage.AccommodationPicking, "replace");
      }

      setDateRange([startDate, endDate]);
    }
    // eslint-disable-next-line
  }, []);
};
